import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { DEFAULT_STATE } from './redux.js';
import ActionPreviewHeader from './ActionPreviewHeader.js';
import DiffTab from './tabs/DiffTab.js';
import StateTab from './tabs/StateTab.js';
import ActionTab from './tabs/ActionTab.js';
const DEFAULT_TABS = [
    {
        name: 'Action',
        component: ActionTab,
    },
    {
        name: 'Diff',
        component: DiffTab,
    },
    {
        name: 'State',
        component: StateTab,
    },
];
class ActionPreview extends Component {
    constructor() {
        super(...arguments);
        this.labelRenderer = ([key, ...rest], nodeType, expanded) => {
            const { onInspectPath, inspectedPath } = this.props;
            return (_jsxs("span", { children: [_jsx("span", { children: key }), _jsx("span", { css: (theme) => ({
                            fontSize: '0.7em',
                            paddingLeft: '5px',
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                            color: theme.PIN_COLOR,
                        }), onClick: () => onInspectPath([
                            ...inspectedPath.slice(0, inspectedPath.length - 1),
                            ...[key, ...rest].reverse(),
                        ]), children: '(pin)' }), !expanded && ': '] }));
        };
    }
    render() {
        const { delta, error, nextState, onInspectPath, inspectedPath, tabName, isWideLayout, onSelectTab, action, actions, selectedActionId, startActionId, computedStates, base16Theme, invertTheme, tabs, dataTypeKey, monitorState, updateMonitorState, sortStateTreeAlphabetically, disableStateTreeCollection, } = this.props;
        const renderedTabs = typeof tabs === 'function'
            ? tabs(DEFAULT_TABS)
            : tabs
                ? tabs
                : DEFAULT_TABS;
        const { component: TabComponent } = renderedTabs.find((tab) => tab.name === tabName) ||
            renderedTabs.find((tab) => tab.name === DEFAULT_STATE.tabName);
        return (_jsxs("div", { css: (theme) => ({
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflowY: 'hidden',
                '& pre': {
                    border: 'inherit',
                    borderRadius: '3px',
                    lineHeight: 'inherit',
                    color: 'inherit',
                },
                backgroundColor: theme.BACKGROUND_COLOR,
            }), children: [_jsx(ActionPreviewHeader, { tabs: renderedTabs, inspectedPath, onInspectPath, tabName, onSelectTab }), !error && (_jsx("div", { css: { flex: 1, overflowY: 'auto' }, children: _jsx(TabComponent, { labelRenderer: this.labelRenderer, computedStates,
                        actions,
                        selectedActionId,
                        startActionId,
                        base16Theme,
                        invertTheme,
                        isWideLayout,
                        sortStateTreeAlphabetically,
                        disableStateTreeCollection,
                        dataTypeKey,
                        delta,
                        action,
                        nextState,
                        monitorState,
                        updateMonitorState }) }, "actionPreviewContent")), error && (_jsx("div", { css: (theme) => ({
                        padding: '10px',
                        marginLeft: '14px',
                        fontWeight: 'bold',
                        color: theme.ERROR_COLOR,
                    }), children: error }))] }, "actionPreview"));
    }
}
ActionPreview.defaultProps = {
    tabName: DEFAULT_STATE.tabName,
};
export default ActionPreview;
